import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { ApplySessionPayload, BaseAction, SessionActionType } from '../store.actions';

export interface TwoFactorState {
  enrollmentRequired: boolean;
}
const initialState: TwoFactorState = { enrollmentRequired: false };

export function twoFactorReducer(state: TwoFactorState = initialState, action: BaseAction): TwoFactorState {
  switch (action.type) {
    case SessionActionType.APPLY_SESSION:
      // The enrollment flag is set ONLY by the shared atomic session action (the auth reducer handles the
      // identity half, so both slices update in one emission). Every write — login, cross-tab sync, and
      // teardown (APPLY_SESSION with EMPTY_AUTH + enrollmentRequired:false) — goes through here, so there
      // is no separate set/clear action to keep ordered against the auth slice. See SessionActionType.
      return { ...state, enrollmentRequired: !!(action.payload as ApplySessionPayload)?.enrollmentRequired };
    default:
      return state;
  }
}

export const TWO_FACTOR_FEATURE = 'twoFactor';
export const selectTwoFactor = createFeatureSelector<TwoFactorState>(TWO_FACTOR_FEATURE);
export const selectEnrollmentRequired: MemoizedSelector<object, boolean> =
  // Null-safe: the feature reducer always seeds the slice, but guard against an early/partial store
  // emission (before this feature registers) so a consumer guard fails open (false) rather than throwing.
  createSelector(selectTwoFactor, (s) => !!s?.enrollmentRequired);
